import * as types from 'reducer/actionTypes'

const initialState = {
	// search 조회 후 검색조건 저장
	checkIP: null,
	remoteAddr: null,
	id:'',
	pw: '',
	error:null
};

export default function stats(state = initialState, action){
	switch(action.type){
		case types.SET_USER_ID :
			return{
				...state,
				id: action.id
			}
		case types.SET_USER_PW :
			return{
				...state,
				pw: action.pw
			}

		//SUCCESS
		case types.FETCH_CHECKIP_SUCCESS :
			return{
				...state,
				checkIP: action.checkIP,
				remoteAddr: action.remoteAddr,
				error: initialState.error
			}

		case types.FETCH_LOGIN_SUCCESS :
			window.location.reload();
			return{
				...state,
				error: initialState.error
			}

		case types.FETCH_LOGOUT_SUCCESS :
			window.location.reload();
			return{
				...state,
				error: initialState.error
			}

		//FAILURE

		default:
			return state
	}
}